import { render } from "./CaseLaboratory.vue?vue&type=template&id=5887e8cf&scoped=true&ts=true"
import script from "./CaseLaboratory.vue?vue&type=script&lang=ts"
export * from "./CaseLaboratory.vue?vue&type=script&lang=ts"

import "./CaseLaboratory.vue?vue&type=style&index=0&id=5887e8cf&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5887e8cf"]])

export default __exports__